<div
  class="btn-group-height rounded-2 py-1"
  [ngClass]="'border ' + (showError ? 'border-colour-red-700' : 'border-colour-grayscale-600')"
  [class.is-invalid]="showError"
>
  <div
    class="btn-group d-flex"
    role="group"
  >
    @for (option of optionsArray; track option; let idx = $index; let first = $first) {
      <div
        class="col px-1"
        [class.border-start]="!first"
      >
        <input
          type="radio"
          class="btn-check"
          [id]="id + '_' + idx"
          [formControl]="$any(formControl)"
          [value]="option.value"
          [formlyAttributes]="field"
          [attr.data-testid]="props.testId + '_' + idx"
          [name]="key + id"
        />
        <label
          class="btn w-100 py-auto"
          [class.btn-colour-blue-600]="formControl.value === option.value"
          [class.text-colour-red-700]="showError"
          [for]="id + '_' + idx"
        >
          {{ option.label }}
        </label>
      </div>
    }
  </div>
</div>
